export const blockIconsContentPushPin = (
	<span className='material-symbols-outlined'>push_pin</span>
);
